module.exports = __webpack_public_path__ + "static/media/21.2d319a37.mp3";